import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import Stars from 'components/rating/Stars/Stars'

import s from './RatingStars.scss'


const RatingStars = (props) => {
  const { className, xsm, sm, md, lg, xlg, value, isBlack, isRed, count, withNumbers, onClick } = props

  const intValue        = value || 0
  const containerWidth  = intValue * 100 / count

  const rootClassName = cx(s.ratingStars, className, {
    // sizes
    [s.tenStars]: count === 10,
    [s.xsm]: xsm,
    [s.sm]: sm,
    [s.md]: md,
    [s.lg]: lg,
    [s.xlg]: xlg,
  })

  return (
    <div className={rootClassName}>
      <div className={s.activeStarsContainer} style={{ width: `${containerWidth}%` }}>
        <Stars
          className={s.activeStars}
          active
          count={count}
          isRed={isRed}
          isBlack={isBlack}
          onClick={onClick}
        />
      </div>
      <Stars
        className={s.backdropStars}
        count={count}
        withNumbers={withNumbers}
        onClick={onClick}
      />
    </div>
  )
}

RatingStars.propTypes = {
  // sizes
  xsm: PropTypes.bool,
  sm: PropTypes.bool,
  md: PropTypes.bool,
  lg: PropTypes.bool,
  xlg: PropTypes.bool,

  className: PropTypes.string,
  count: PropTypes.number,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  isBlack: PropTypes.bool,
  onClick: PropTypes.func,
}

RatingStars.defaultProps = {
  count: 5,
}


export default RatingStars
